import React, { useState } from 'react';
import { AppBar, Box, IconButton, List, ListItem, ListItemText, makeStyles, Slide, Toolbar, Typography, useScrollTrigger } from '@material-ui/core';
import { graphql, navigate, useStaticQuery } from 'gatsby';
import MenuIcon from '@material-ui/icons/Menu';
import Logo from './logo';
import {Link, Button} from 'gatsby-theme-material-ui'
import { CustomDrawer } from './custom-drawer/custom-drawer';
import {useStateWithCallbackLazy} from 'use-state-with-callback';

const useStyles = makeStyles(({spacing, breakpoints})=>({
  root: {

  },
  toolBarContainer: {
    maxWidth: breakpoints.values.lg,
    marginLeft: 'auto',
    marginRight: 'auto',
    width: '100%'
  },
  leftSide: {
    flexGrow: 1
  },
  getStartedButton: {
    marginRight: spacing(2),
  }
}))

interface HideOnScrollProps {
  children: React.ReactElement;
}

function HideOnScroll(props:HideOnScrollProps) {
  const { children } = props;
  const trigger = useScrollTrigger();
  
  return (
    <Slide appear={false} direction="down" in={!trigger}>
      {children}
    </Slide>
  );
}

const Header: React.FC = () => {
  const classes = useStyles()
  const [openDrawer, setOpenDrawer] = useStateWithCallbackLazy(false)
  const { site, allBuilderModels } = useStaticQuery(graphql`
    query {
      site {
        siteMetadata {
          title
        }
      }
      allBuilderModels {
        headerdata {
          data {
            linkList
          }
        }
      }
    }
  `);

  const handleLinkClick = (url:string) => {
    setOpenDrawer(false, ()=> {
      navigate(url)
    })
  }
  

  const headerLinks = allBuilderModels.headerdata[0].data.linkList

  type HeaderLink = {
    name: string,
    url: string
  }


  return (
    <>
    {/* <HideOnScroll> */}
      <AppBar color="default" position="fixed" variant="outlined" elevation={0}>
        <Box className={classes.toolBarContainer}>
          <Toolbar >
            <Box className={classes.leftSide}>
              <Link  to='/'>
                <Logo variant="primary" width="91" height="25.82" />
              </Link> 
            </Box>

            <Button className={classes.getStartedButton} size="large" to="/trainers" variant="contained" disableElevation color="primary">Get started</Button>
            <IconButton onClick={()=>setOpenDrawer(true)} edge="start" color="inherit" aria-label="menu">
              <MenuIcon />
            </IconButton>
          </Toolbar>
        </Box>
      </AppBar>
    {/* </HideOnScroll> */}
    <Box pt={7} />
    <CustomDrawer hideHeader onClose={()=>setOpenDrawer(false)} open={openDrawer}>
      <Box minHeight="30vh">
        <List component="nav" aria-label="main links">
          {
            headerLinks.map((linkObj: HeaderLink) => (
              <ListItem key={linkObj.url} onClick={()=>handleLinkClick(linkObj.url)} button>
                <ListItemText primary={linkObj.name}></ListItemText>
              </ListItem>
            ))
          }
        </List>
      </Box>
    </CustomDrawer>
    </>
  );
}

export default Header;
